export default __webpack_public_path__ + "static/media/logo-white.e50376f7.svg";